import requestFunctions from "../../functions/requestFunctions";


export const state = {
  SKILLS_ITEM: {},
  SKILLS_LIST: [],
  SKILLS_TABLE_DATA: [],
  SKILLS_LIST_DATA: [],
  SKILLS_TOTAL_ROWS: 0
}

export const getters = {
  GET_SKILLS_ITEM: (state) => {
    return state.SKILLS_ITEM;
  },
  GET_SKILLS_LIST: (state) => {
    return state.SKILLS_LIST;
  },
  GET_SKILLS_TABLE_DATA: (state) => {
    return state.SKILLS_TABLE_DATA;
  },
  GET_SKILLS_LIST_DATA: (state) => {
    return state.SKILLS_LIST_DATA;
  },
  GET_SKILLS_TOTAL_ROWS: (state) => {
    return state.SKILLS_TOTAL_ROWS;
  }
}

export const mutations = {

  UPDATE_SKILLS_ITEM(state, item) {
    state.SKILLS_ITEM = item;
  },

  UPDATE_SKILLS_LIST(state, list) {
    
    state.SKILLS_LIST = list.data;

    state.SKILLS_TOTAL_ROWS = list.total;
    list = list.data;
    
    state.SKILLS_TABLE_DATA = [];
    state.SKILLS_LIST_DATA = [];

    list.forEach(el => {

      let user_data = '';
    
      if(el.profile_fullname !== null){
        user_data = el.profile_fullname;
      }
      
      if(el.user_phone !== null ){
        if(user_data !== ''){
          user_data = user_data + ', ';
        }
        user_data = user_data + el.user_phone;
      }

      let dev_data = '';

      if(el.dev_profile_fullname !== null){
        dev_data = el.dev_profile_fullname;
      }
      
      if(el.dev_phone !== null ){
        if(dev_data !== ''){
          dev_data = dev_data + ', ';
        }
        dev_data = dev_data + el.dev_phone;
      }

      state.SKILLS_TABLE_DATA.push({
        'name' : el.name,
        'id' : el.id,
        'user_data' : user_data,
        'dev_data' : dev_data,
        'updated_at' : el.updated_at,
        'description' : el.description,
        'uuid' : el.uuid,
        'version': el.version,
        'owner_id': el.owner_id,
        'user_id': el.user_id
      });

      state.SKILLS_LIST_DATA.push({
        id: el.id,
        uuid: el.uuid,
        name: el.name,
        code: el.code,
      });
    });
  },
}

export const actions = {

  async FETCH_SKILLS_ITEM({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/skills/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_SKILLS_ITEM', response.data);
      return response.data;
    }

  },

  async FETCH_SKILLS_LIST({ commit }, payload= {}) {

    let query_url = 'https://api.client.za-bota.com/v1/skills';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_SKILLS_LIST', response.data);
      return response.data;
    }

  },

  async FETCH_SKILLS_CREATE({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/skills';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'POST');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }

  },

  async FETCH_SKILLS_UPDATE({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/skills/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'PUT');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }

  },

  async FETCH_SKILLS_DELETE({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/skills/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'DELETE');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }

  },

}